// Converts underscore_keys to "Title Case Words"
export const cap = s => s ? s.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : '';
